import { animationRotate, LOADER_PHASES } from '../utils';
import { Pane } from 'evergreen-ui';
import styled from 'styled-components';

const StyledLoader = styled(Pane)`
  position: relative;
  display: flex;
  align-items: center;
  color: #a7aaac;
  height: 36px;
  font-size: 16px;
  font-weight: 500;
  padding-left: 52px;
  .animationContainer {
    position: absolute;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
  }
`;

const StyledLoadingAnimation = styled.svg`
  position: absolute;
  animation: ${animationRotate} 2s linear infinite;
  transition: all 0.5s;
  opacity: 0;
  width: 10px;

  &.loading {
    opacity: 1;
    width: 36px;
  }
`;
const LoadingAnimation = ({ status }) => (
  <StyledLoadingAnimation
    className={status}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.1699 25.2331C1.66182 22.1411 1.15791 18.655 1.72867 15.2625C2.29943 11.87 3.9163 8.74072 6.35312 6.31239C8.78994 3.88406 11.9248 2.27812 15.3193 1.71921C18.7138 1.1603 22.1981 1.67637 25.2848 3.19524"
      stroke="url(#paint0_linear_1115_4949)"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.7363 13.0384C34.638 15.8981 34.7433 18.9496 34.041 21.8647C33.3387 24.7799 31.8552 27.4485 29.7501 29.5839C27.6449 31.7192 24.9977 33.2405 22.0928 33.9843C19.188 34.7281 16.1353 34.6663 13.263 33.8054"
      stroke="url(#paint1_linear_1115_4949)"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1115_4949"
        x1="36"
        y1="19.2"
        x2="-17.9936"
        y2="13.6578"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E78850" />
        <stop offset="1" stopColor="#FFA46F" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1115_4949"
        x1="36"
        y1="19.2"
        x2="-17.9936"
        y2="13.6578"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E78850" />
        <stop offset="1" stopColor="#FFA46F" />
      </linearGradient>
    </defs>
  </StyledLoadingAnimation>
);

const PausedIcon = ({ status }) => (
  <StyledLoadingAnimation
    className={status}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.1699 25.2331C2.22003 23.2856 1.66306 21.1701 1.53078 19.0073C1.3985 16.8445 1.6935 14.6769 2.39894 12.6281C3.10439 10.5794 4.20646 8.68961 5.64223 7.06677C7.07801 5.44392 8.81936 4.11976 10.7669 3.1699C12.7144 2.22003 14.8299 1.66306 16.9927 1.53078C19.1555 1.3985 21.3231 1.6935 23.3719 2.39895C25.4206 3.10439 27.3104 4.20646 28.9332 5.64223C30.5561 7.07801 31.8802 8.81936 32.8301 10.7669C33.78 12.7144 34.3369 14.8299 34.4692 16.9927C34.6015 19.1555 34.3065 21.3231 33.6011 23.3719C32.8956 25.4206 31.7935 27.3104 30.3578 28.9332C28.922 30.5561 27.1806 31.8802 25.2331 32.8301C23.2856 33.78 21.1701 34.3369 19.0073 34.4692C16.8445 34.6015 14.6769 34.3065 12.6281 33.6011C10.5794 32.8956 8.68961 31.7935 7.06676 30.3578C5.44392 28.922 4.11976 27.1806 3.16989 25.2331L3.1699 25.2331Z"
      stroke="#3E4143"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StyledLoadingAnimation>
);

const DisconnectedIcon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.1699 25.2331C2.22003 23.2856 1.66306 21.1701 1.53078 19.0073C1.3985 16.8445 1.6935 14.6769 2.39894 12.6281C3.10439 10.5794 4.20646 8.68961 5.64223 7.06677C7.07801 5.44392 8.81936 4.11976 10.7669 3.1699C12.7144 2.22003 14.8299 1.66306 16.9927 1.53078C19.1555 1.3985 21.3231 1.6935 23.3719 2.39895C25.4206 3.10439 27.3104 4.20646 28.9332 5.64223C30.5561 7.07801 31.8802 8.81936 32.8301 10.7669C33.78 12.7144 34.3369 14.8299 34.4692 16.9927C34.6015 19.1555 34.3065 21.3231 33.6011 23.3719C32.8956 25.4206 31.7935 27.3104 30.3578 28.9332C28.922 30.5561 27.1806 31.8802 25.2331 32.8301C23.2856 33.78 21.1701 34.3369 19.0073 34.4692C16.8445 34.6015 14.6769 34.3065 12.6281 33.6011C10.5794 32.8956 8.68961 31.7935 7.06676 30.3578C5.44392 28.922 4.11976 27.1806 3.16989 25.2331L3.1699 25.2331Z"
      stroke="#3E4143"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <line x1="23" y1="12.1213" x2="12.1213" y2="23" stroke="#3E4143" stroke-width="3" stroke-linecap="round" />
  </svg>
);

const SmallLoader = ({ phase, isLinked }) => {
  const loading = [LOADER_PHASES.INITIATING, LOADER_PHASES.SEARCHING].includes(phase);
  return (
    <StyledLoader>
      <div className="animationContainer">
        {isLinked ? (
          <>
            <LoadingAnimation status={loading ? 'loading' : ''} />
            <PausedIcon status={!loading ? 'loading' : ''} />
          </>
        ) : (
          <DisconnectedIcon />
        )}
      </div>
      <div>{phase}</div>
    </StyledLoader>
  );
};

export default SmallLoader;
